import CircularProgress from "@mui/material/CircularProgress";

import { useState } from "react";

export default function Progress(load) {
  const [loading, setLoading] = useState(load);
  return (
    loading && (
      <CircularProgress
        aria-label="Loading…"
        size={50}
        sx={{
          color: "#000",
          position: "absolute",
          top: "50%",
          left: "50%",
          zIndex: 100,
        }}
      />
    )
  );
}
